module.exports = __webpack_public_path__ + "media/images/front/icons/logout-a1bb85eeb4ccadb59ac2f7a75688e099.png";